import ACCPBossTableContainer from './ACCPBossTableContainer';

export default ACCPBossTableContainer;